var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.list),function(item,index){return _c('list-item',_vm._g({key:`medical-report-library-item-category-${_vm.topic.id}-${index}`,attrs:{"item":item,"selected":_vm.isActive(item)}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }